import React, { useCallback, useMemo, type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { getUserLocation } from '@atlassian/jira-platform-router-utils';
import { Fallback } from './fallback';

export type SidebarBoundaryProps = {
	children: ReactNode;
	id: string;
	packageName: string;
};

export const SidebarBoundary = ({ children, id, packageName }: SidebarBoundaryProps) => {
	const userLocation = getUserLocation();

	const extraEventData = useMemo(() => ({ userLocation }), [userLocation]);

	const fallback = useCallback(({ error }: { error: Error }) => <Fallback error={error} />, []);

	return (
		<JSErrorBoundary
			id={id}
			packageName={packageName}
			extraEventData={extraEventData}
			fallback={fallback}
		>
			{children}
		</JSErrorBoundary>
	);
};
